if (!customElements.get("nss-footer")) {
  class NSSFooter extends HTMLElement {
    constructor() {
      super();
      this.debug = false;
    }

    closeAllGroups() {
      this.querySelectorAll('[nss-footer-menu-group]').forEach((group) => {
        group.setAttribute('nss-footer-menu-group-open', false);
      });
    }

    connectedCallback() {
      if (this.debug) console.log('[NSS] Footer connected.');
      this.querySelectorAll('[nss-footer-menu-group]').forEach((group) => {
        const button = group.querySelector('[nss-footer-menu-group-btn]');
        if (!button || button.dataset.bound === 'true') return;
        button.dataset.bound = 'true';
        button.addEventListener('click', () => {
          const isOpen = group.getAttribute('nss-footer-menu-group-open') === 'true';
          if (isOpen) {
            group.setAttribute('nss-footer-menu-group-open', false);
          } else {
            this.closeAllGroups();
            group.setAttribute('nss-footer-menu-group-open', true);
          }
        });
      });
    }
  }

  customElements.define('nss-footer', NSSFooter);
}
